var app = angular.module('leonardo');

var UserInitialsFilter = function () {
  return function (user) {
    if (!user) return '';
    var values = [];
    if (user.first_name) values.push(user.first_name.substring(0, 1));
    if (user.last_name) values.push(user.last_name.substring(0, 1));
    return values.join('');
  }
};

app.filter('user_initials', [UserInitialsFilter]);
